import axios from 'axios';
const apiKey = '54266757-223a8fcde2c0e71951b4feb81';
const baseUrl = 'https://pixabay.com/api/';
export async function getImagesByQuery(query, page = 1) {
    const params = {
        key: apiKey,
        q: query,
        image_type: 'photo',
        orientation: 'horizontal',
        safesearch: true,
        page: page,
        per_page: 15,
    };
    const response = await axios.get(baseUrl, {params});
    return response.data;
}